<template>
  <div id="app">
    <!-- Nowy layout Peakslog (ekrany z designu) -->
    <div v-if="layout === 'peakslog'" class="pl-app">
      <PlAppHeader v-if="route.meta.appNav" />
      <SyncStatusBar v-if="showSyncBar" />
      <router-view />
    </div>

    <!-- Widoki legacy (mapa, szczyty, aktywności, rankingi, admin) -->
    <template v-else-if="layout === 'legacy'">
      <AppHeader v-if="isAuthenticated" />
      <SyncStatusBar v-if="isAuthenticated" />
      <main class="main-content">
        <router-view />
      </main>
      <AppFooter v-if="showFooter" />
    </template>

    <router-view v-else />
  </div>
</template>

<script setup>
import { computed, watchEffect } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useRoute } from 'vue-router'
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import SyncStatusBar from '@/components/SyncStatusBar.vue'
import PlAppHeader from '@/components/pl/PlAppHeader.vue'

const authStore = useAuthStore()
const route = useRoute()

const isAuthenticated = computed(() => authStore.isAuthenticated)

// Dopóki router nie rozwiąże pierwszej trasy, nie renderujemy żadnego shella
const layout = computed(() => {
  if (!route.matched.length) return 'none'
  return route.meta.layout || 'legacy'
})

// Pasek synchronizacji tylko na ekranach aplikacji wymagających Stravy (nie na kartach share)
const showSyncBar = computed(() => isAuthenticated.value && route.meta.requiresStrava && !route.meta.hideSyncBar)

watchEffect(() => {
  document.body.classList.toggle('pl-body', layout.value !== 'legacy')
})

// Stopka widoków legacy (dla zalogowanych)
const showFooter = computed(() => isAuthenticated.value)
</script>

<style>
/* CSS Custom Properties - Color Palette */
:root {
--primary-color: #6588b3;           /* Główny niebieski */
--primary-hover: #4c6986;           /* Ciemniejszy niebieski */
--primary-gradient-start: #6588b3;
--primary-gradient-end: #415971;    /* Najciemniejszy niebieski */

--secondary-color: #415971;          /* Ciemny niebiesko-szary */
--secondary-hover: #537291;          /* Średni niebieski */
--secondary-gradient-start: #dfc4b9;
--secondary-gradient-end: #f7b599;

--text-primary: #2b3b4e;             /* Średni niebieski */
--text-secondary: #4c6986;           /* Jasny szary */
--text-muted: #88a6c0;                 /* Bardzo jasny niebieski */
--text-light: #e9c4b4;               /* Ciepły różowawy */

--bg-light: #e0ecf5;                 /* Bardzo jasny niebieski */
--bg-light-accent: #b4b9cd;          /* Jasny szary */
--bg-success: #e9c4b4;               /* Ciepły różowawy */
--bg-white: #FFFFFF;

--chart-primary: #6588b3;
--chart-secondary: #88a6c0;
--chart-tertiary: #415971;
--chart-point-bg: #FFFFFF;

--btn-google: #4285F4;
--btn-google-hover: #3367D6;

--btn-strava: #FC4C02;
--btn-strava-hover: #E84300;

--error-color: #D32F2F;
--error-text: #B71C1C;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text-primary);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  transition: padding-top 0.3s ease;
}

@media (max-width: 768px) {
  .main-content {
    padding: 1rem;
  }
}
</style>
